<!--
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version: 
 * @Author: Duanshuai
 * @Date: 2021-04-28 09:38:23
 * @LastEditors: ------
 * @LastEditTime: 2021-09-13 14:37:06
-->
<template>
  <div class="none">
    <el-empty description="没有找到此页面！"></el-empty>
  </div>
</template>
<script>
export default {
  name: ""
};
</script>
<style scoped>
.none {
  height: 100vh;
  margin-top: 100px;
}
.font {
  font-size: 24px;
  color: #707070;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue